// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2yoGQ","paramInput":"JobSimulator_paramInput__345Dw","input":"JobSimulator_input__NEtdD"};